import "core-js/modules/es.array.is-array.js";
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function statusChangesFromApplication(state) {
  var _state$application, _state$application$ap;
  // eslint-disable-line @typescript-eslint/no-explicit-any
  return state === null || state === void 0 ? void 0 : (_state$application = state.application) === null || _state$application === void 0 ? void 0 : (_state$application$ap = _state$application.application) === null || _state$application$ap === void 0 ? void 0 : _state$application$ap.status_changes;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function statusChangesFromStatus(state) {
  var _state$application2, _state$application2$a, _state$application2$a2;
  // eslint-disable-line @typescript-eslint/no-explicit-any
  return state === null || state === void 0 ? void 0 : (_state$application2 = state.application) === null || _state$application2 === void 0 ? void 0 : (_state$application2$a = _state$application2.application) === null || _state$application2$a === void 0 ? void 0 : (_state$application2$a2 = _state$application2$a.status) === null || _state$application2$a2 === void 0 ? void 0 : _state$application2$a2.status_changes;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function applicationStateChangesSelector(state) {
  // eslint-disable-line @typescript-eslint/no-explicit-any
  var initialStatusChanges = statusChangesFromApplication(state);
  var updatedStatusChanges = statusChangesFromStatus(state);
  if (Array.isArray(initialStatusChanges) && Array.isArray(updatedStatusChanges)) {
    return initialStatusChanges.length > updatedStatusChanges.length ? initialStatusChanges : updatedStatusChanges;
  }
  return Array.isArray(initialStatusChanges) ? initialStatusChanges : [];
}